'use client'
import styles from '../OnboardingForm.module.scss'
import formStyles from '../../../blocks/ContentBlock/FormBlock/FormBlock.module.scss'
import bgimage from './bgimage.svg'
import bgimageMobile from './bgimage-mobile.svg'
import { useContext, useState } from 'react'
import { readStoredData } from '@/src/components/common/OnboardingForm/OnboardingForm.client'
import Img from '@/src/components/common/Img/Img'
import Field from '@/src/components/blocks/ContentBlock/FormBlock/FormBlock.Field.client'
import Select from '@/src/components/common/Select'
import { DirectusContext } from '@/src/contexts/DirectusContext'

export default function ContactDetailsForm() {
  const [onboardingData] = useState(readStoredData())

  const stage = onboardingData.data['homecare_stage'] as string
  const directusContext = useContext(DirectusContext)
  const privacyPolicyPage = directusContext.SITE_SETTINGS.privacy_policy_page

  if (!privacyPolicyPage) {
    throw new Error('Privacy Policy Page not set in Site Settings')
  }

  return (
    <>
      <div>
        <div>
          <h3 className={styles.heading}>
            One last step, what are your preferred contact details?
          </h3>
          Your details help us make your next steps simple and take the stress out of getting care.
        </div>
        <div className={formStyles.formContent}>
          {(name => (
            <Field
              required
              label={'First name'}
              input={
                <input
                  name={name}
                  defaultValue={onboardingData.data[name]}
                  type={'text'}
                  placeholder={'First name'}
                  autoComplete={'off'}
                />
              }
              className={formStyles.half}
            />
          ))('contact__first_name')}

          {(name => (
            <Field
              required
              label={'Last name'}
              input={
                <input
                  name={name}
                  defaultValue={onboardingData.data[name]}
                  type={'text'}
                  placeholder={'Last name'}
                  autoComplete={'off'}
                />
              }
              className={formStyles.half}
            />
          ))('contact__last_name')}

          {(name => (
            <Field
              required={['switch_provider', 'with_homecare_package'].includes(stage)}
              label={'Phone number'}
              input={
                <input
                  name={name}
                  defaultValue={onboardingData.data[name]}
                  type={'text'}
                  placeholder={'Phone number'}
                  autoComplete={'off'}
                  pattern={'(0)(4|5)[0-9]{8}'}
                  minLength={10}
                  maxLength={10}
                />
              }
              className={formStyles.half}
            />
          ))('contact__phone_number')}

          {(name => (
            <Field
              required={!['switch_provider', 'with_homecare_package'].includes(stage)}
              label={'Email address'}
              input={
                <input
                  name={name}
                  defaultValue={onboardingData.data[name]}
                  type={'email'}
                  placeholder={'Email address'}
                  autoComplete={'off'}
                />
              }
              className={formStyles.half}
            />
          ))('contact__email_address')}

          {['switch_provider', 'with_homecare_package'].includes(stage) && (
            <>
              {(name => (
                <Field
                  required
                  label={'Postcode'}
                  input={
                    <input
                      name={name}
                      defaultValue={onboardingData.data[name]}
                      type={'text'}
                      placeholder={'Postcode'}
                      autoComplete={'off'}
                    />
                  }
                  className={formStyles.half}
                />
              ))('contact__postcode')}

              {(name => {
                const options = [
                  'No preference (9am - 5pm)',
                  'Morning (9am - 11am)',
                  'Afternoon (12pm - 5pm)',
                ]
                const selectedIdx = options.indexOf(onboardingData.data?.[name] as string)
                return (
                  <Field
                    label={'Preferred contact time'}
                    input={
                      <Select
                        name={name}
                        options={options}
                        default={selectedIdx < 0 ? null : selectedIdx}
                      />
                    }
                    className={formStyles.half}
                  />
                )
              })('contact__contact_time')}

              {(name => (
                <Field
                  label={'Tell us more about what you’re looking for in your home care journey'}
                  input={
                    <textarea
                      name={name}
                      defaultValue={onboardingData.data[name]}
                      placeholder={'Enter details here'}
                      autoComplete={'off'}
                      rows={3}
                    />
                  }
                  className={formStyles.half}
                />
              ))('contact__looking_for')}
            </>
          )}
        </div>
        <div>
          {`By clicking "Submit", I accept the `}
          <a href={`/${privacyPolicyPage.slug}/`} target={'_blank'}>
            Privacy Policy
          </a>
          {` and I acknowledge that I can opt out from contact at any time.`}
        </div>
      </div>
      <div>
        <Img src={bgimage.src} className={styles.desktop} />
        <Img src={bgimageMobile.src} className={styles.mobile} />
      </div>
    </>
  )
}
